module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/File-plus-db00216e9da5f091bb627286df0590ca.svg";